<template>
    <div class="Loading-Box" v-show="loadingShow">
        <img src="./load.svg" alt="" srcset="">
    </div>
</template>

<script>
    export default {
        name: "loading",
        components: {
        },
        data() {
            return {
                loadCount: 0,
                loadingShow: false,
               
            };
        },
        methods: {
            show() {
                this.loadingShow = true;
                this.loadCount++;
            },
            close() {
                if(this.loadCount>0) this.loadCount--;
                if (this.loadCount <= 0) {
                    this.loadingShow = false;
                }
            },
            errClose() {
                this.loadCount = 0;
                this.loadingShow = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
@keyframes rotateImg {
    0%{
        transform: rotate(0deg);
    }100%{
        transform: rotate(360deg);
    }
}

.Loading-Box{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        animation: rotateImg 1s linear infinite;
        width: 30px;
    }
}
   
</style>
